(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-cookie-preferences"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-bb-cookie-preferences]');
    if (!button) return;
    const message = button.parentElement.querySelector('.bb-cookie-preferences__error');
    message.hidden = true;
    button.disabled = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Preferences unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      message.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
